<template>
<div id="contents">
     <!-- 头部组件 -->
     <component :is="header_"></component>
     <!--  -->
    <el-container class="el-container-vh" style="border: 1px solid #eee">
      <!-- 侧栏组件 -->
      <component :is="celan"></component>

      <el-container>
        <div style="padding: 8px;" class="upload-max">
           <el-upload
            class="upload-demo"
            drag
            :action="upimgurl"
            :on-success="uploadSuccess"
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击选择</em></div>
            <div class="el-upload__tip" slot="tip"> 
              <!-- 上传收款码 -->
            </div>
           </el-upload>
           <!--  -->
           <div>
             <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
               <el-form-item label="收款码类型" style="display: none;">
                  <el-input v-model="formLabelAlign.leixing" placeholder="收款码类型"></el-input>
                </el-form-item>
                <el-form-item label="设备号" style="display: none;">
                  <el-input v-model="formLabelAlign.device" placeholder="设备号"></el-input>
                </el-form-item>
                <el-form-item label="备注信息">
                  <el-input v-model="formLabelAlign.beizhu" placeholder="备注信息"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button class="submit" type="primary" @click="submitForm()">提交</el-button>
                </el-form-item>
              </el-form>
            </div>
        </div>
      </el-container>
    </el-container>
</div>
</template>

<script>
//头部组件
import header_ from './header_.vue'
import celan from './celan.vue'
export default {
  name: 'header_',
   data() {
      return {
        tableData: null,
        total:null,
        header_:header_,
        celan:celan,
        labelPosition: 'top',
        formLabelAlign: {
          payimg: '',
          leixing: 'wx',
          device: '1',
          beizhu: ''
        },
        upimgurl:'./login.php',
      }
    },
     methods: {
      //上传二维码
      submitForm() {
        if(this.formLabelAlign.payimg==''){
            this.$notify.error({
              title: '系统提示',
              message: '请上传图片！'
            });
        }else{
            if(this.formLabelAlign.device==''){
              this.$notify.error({
                title: '系统提示',
                message: '设备号不能为空！'
              });
            }else{
              this.$http.post(this.upimgurl,{datas:this.formLabelAlign},{emulateJSON:true}).then(res=>{
                   this.$notify({
                    title: '系统提示',
                    message: '上传成功',
                    type: 'success'
                   });
              })
            };
        };
      },
      // 上传成功后的回调
      uploadSuccess (response, file, fileList) {
         this.formLabelAlign.payimg=response;
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {

      }


    },
    created(){

       
    }
}
</script>


<style scoped>
.el-form-item {
    margin-bottom: 0px;
}
>>> .el-form--label-top .el-form-item__label {
    padding: 0px;
}
.submit{
    width: 100%;
    margin-top: 19px;
}
.el-container-vh{
  height: 100vh;
}
@media screen and (max-width: 800px) {
  .el-container-vh{
    height: 100%;
  }
  .upload-max{
    margin:0 auto;
  }
}
@media screen and (width: 360px) {
  >>> .upload-demo .el-upload-dragger {
    width: 320px;
  }
}
@media screen and (width: 320px) {
  >>> .upload-demo .el-upload-dragger {
    width: 300px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contents.vue